import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

import { AppIconComponent } from '../app-icon/app-icon.component';

/**
 * Página marcador para los módulos de observación aún no implementados en esta entrega
 * (el alcance de esta primera iteración es el Dashboard). Toma título e icono de la ruta.
 */
@Component({
  selector: 'app-placeholder-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppIconComponent],
  template: `
    <div class="mx-auto flex max-w-xl flex-col items-center justify-center py-20 text-center">
      <span
        class="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-50 text-brand-500 dark:bg-brand-500/10"
      >
        <span class="h-8 w-8"><app-icon [name]="data().icon" /></span>
      </span>
      <h1 class="mt-6 text-title-sm font-bold text-gray-900 dark:text-white">{{ data().titulo }}</h1>
      <p class="mt-2 text-theme-sm text-gray-500 dark:text-gray-400">
        Módulo de vigilancia previsto en la arquitectura. Esta primera entrega implementa el
        <span class="font-medium text-gray-700 dark:text-gray-300">Dashboard</span>; este módulo se
        construirá sobre la misma base (layout, tokens, tablas y mocks ya disponibles).
      </p>
    </div>
  `,
})
export class PlaceholderPageComponent {
  private readonly route = inject(ActivatedRoute);
  protected readonly data = toSignal(
    this.route.data.pipe(
      map((d) => ({ titulo: (d['titulo'] as string) ?? 'Módulo', icon: (d['icon'] as string) ?? 'default' })),
    ),
    { initialValue: { titulo: 'Módulo', icon: 'default' } },
  );
}
